// @ts-nocheck
import * as React from 'react';
import Icon from '../../components/common/Icon';
import { PageHero, Section, SendBtn } from '../shared/InternalShared';

// multilingual.jsx — Multilingual Communication. Accent: cyan.
// "Every parent understood. In their language."

import { useState } from "react";

// Native-script labels + a live sample PTM notification per language.
const ML_LANGUAGE_OPTIONS = [
  { key: "Telugu",    native: "తెలుగు",   msg: "గుర్తు: ఆరవ్ తల్లిదండ్రుల–ఉపాధ్యాయ సమావేశం శుక్రవారం సాయంత్రం 4:00కి. దయచేసి మీ హాజరును ధృవీకరించండి." },
  { key: "Hindi",     native: "हिन्दी",   msg: "स्मरण: आरव की पैरेंट–टीचर मीटिंग शुक्रवार शाम 4:00 बजे है। कृपया अपनी उपस्थिति की पुष्टि करें।" },
  { key: "English",   native: "English",  msg: "Reminder: Aarav's parent–teacher meeting is on Friday at 4:00 PM. Please confirm your attendance." },
  { key: "Tamil",     native: "தமிழ்",    msg: "நினைவூட்டல்: ஆரவின் பெற்றோர்–ஆசிரியர் சந்திப்பு வெள்ளிக்கிழமை மாலை 4:00 மணிக்கு. தயவுசெய்து வருகையை உறுதிப்படுத்தவும்." },
  { key: "Bengali",   native: "বাংলা",    msg: "অনুস্মারক: আরভের অভিভাবক–শিক্ষক বৈঠক শুক্রবার বিকাল ৪:০০টায়। অনুগ্রহ করে আপনার উপস্থিতি নিশ্চিত করুন।" },
  { key: "Kannada",   native: "ಕನ್ನಡ",   msg: "ಜ್ಞಾಪನೆ: ಆರವ್ ಅವರ ಪೋಷಕ–ಶಿಕ್ಷಕ ಸಭೆ ಶುಕ್ರವಾರ ಸಂಜೆ 4:00ಕ್ಕೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹಾಜರಾತಿಯನ್ನು ಖಚಿತಪಡಿಸಿ." },
  { key: "Marathi",   native: "मराठी",    msg: "स्मरणपत्र: आरवची पालक–शिक्षक सभा शुक्रवारी संध्याकाळी 4:00 वाजता आहे. कृपया तुमची उपस्थिती निश्चित करा." },
  { key: "Urdu",      native: "اردو",     msg: "یاد دہانی: آرو کی والدین–اساتذہ میٹنگ جمعہ شام 4:00 بجے ہے۔ براہ کرم اپنی حاضری کی تصدیق کریں۔" },
];
const ML_LANGS = ML_LANGUAGE_OPTIONS.filter((language) => ['Telugu', 'Hindi', 'English'].includes(language.key));

export default function PageMultilingual({ student, accent, sendToParent }) {
  const startIdx = Math.max(0, ML_LANGS.findIndex((l) => l.key === student.language));
  const [idx, setIdx] = useState(startIdx === -1 ? 0 : startIdx);
  const lang = ML_LANGS[idx];
  const rtl = lang.key === "Urdu";

  const heroRight = (
    <div className="ip-card ip-rise" style={{ padding: 24, background: "var(--bg)" }}>
      <div className="ip-stat__n" style={{ fontSize: 46, color: "var(--accent)" }}>80<sup>%</sup></div>
      <div style={{ fontSize: 14, fontWeight: 600, color: "var(--fg)", marginTop: 6 }}>of Indian parents aren't fluent in English.</div>
      <div style={{ fontSize: 12.5, color: "var(--fg-secondary)", marginTop: 6, lineHeight: 1.55 }}>So the most important updates go unread — and support reaches the child late.</div>
      <hr className="ip-hr" style={{ margin: "16px 0" }} />
      <div className="ip-statrow">
        <div><div className="ip-stat__n" style={{ fontSize: 22 }}>12<sup>+</sup></div><div className="ip-stat__l">Languages</div></div>
        <div><div className="ip-stat__n" style={{ fontSize: 22 }}>24×7</div><div className="ip-stat__l">IVR line</div></div>
        <div><div className="ip-stat__n" style={{ fontSize: 22 }}>100<sup>%</sup></div><div className="ip-stat__l">Reach</div></div>
      </div>
    </div>
  );

  return (
    <div className="ip" style={{ "--accent": accent }}>
      <PageHero
        eyebrow="Multilingual Communication"
        icon="language"
        title={<>Every parent understood.<br/><span className="ip-accent">In their language.</span></>}
        lead="Powered by the Government of India's Bhashini initiative. One unified ecosystem so no update is ever lost in translation — across app, SMS, WhatsApp and a 24×7 voice line."
        actions={<>
          <SendBtn onClick={() => sendToParent(`Sample update in ${lang.key}`, null, { language: lang.key })} label={`Send in ${lang.key}`} />
        </>}
        trust={{ label: "Inspired by", items: [
          { label: "Bhashini" },
          { label: "Digital India" },
        ] }}
        right={heroRight}
      />

      <Section
        eyebrow="One message · every language"
        title="Watch the same update change language"
        hint={`Default for ${student.name}: ${student.language}. Tap a language to translate live.`}
      >
        <div style={{ display: "grid", gridTemplateColumns: "1fr 300px", gap: 32, alignItems: "center" }}>
          <div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {ML_LANGS.map((l, i) => (
                <button key={l.key} className={"ip-chip" + (i === idx ? " is-on" : "")} onClick={() => setIdx(i)}>
                  {l.native}
                  <span style={{ opacity: 0.6, fontSize: 11 }}>{l.key !== l.native ? l.key : ""}</span>
                </button>
              ))}
            </div>
            <div className="ip-grid ip-grid--2" style={{ marginTop: 22 }}>
              {[
                { t: "In-app updates", d: "Inside the parent app, instantly.", ic: "command" },
                { t: "Instant SMS", d: "For every phone, no app needed.", ic: "comms" },
                { t: "Secure WhatsApp", d: "Where parents already are.", ic: "comms" },
                { t: "24×7 IVR line", d: "A voice call, any hour.", ic: "voice" },
              ].map((c) => (
                <div key={c.t} className="ip-card" style={{ padding: 15, display: "flex", gap: 11, alignItems: "flex-start" }}>
                  <div className="ip-iconbox" style={{ width: 30, height: 30, borderRadius: 8 }}><Icon name={c.ic} size={15} /></div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "var(--fg)" }}>{c.t}</div>
                    <div style={{ fontSize: 11.5, color: "var(--fg-tertiary)", marginTop: 2, lineHeight: 1.4 }}>{c.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Phone mock */}
          <div style={{ justifySelf: "center" }}>
            <div className="ip-phone">
              <div className="ip-phone__screen">
                <div className="ip-phone__status"><span>9:41</span><span>Soomuch Smart</span></div>
                <div className="ip-phone__body">
                  <div className="ip-wa-head">
                    <div className="ip-wa-head__av">S</div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700 }}>Soomuch Smart School</div>
                      <div style={{ fontSize: 10.5, opacity: 0.8 }}>School updates · online</div>
                    </div>
                  </div>
                  <div className="ip-wa-meta">PTM reminder</div>
                  <div className="ip-wa-bubble ip-rise" key={lang.key} style={{ direction: rtl ? "rtl" : "ltr", textAlign: rtl ? "right" : "left" }}>
                    {lang.msg}
                    <div className="ip-wa-bubble__time" style={{ textAlign: rtl ? "left" : "right" }}>9:41 AM ✓✓</div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: 6 }}>
                    <span className="ip-tag" style={{ background: "color-mix(in srgb, var(--accent) 12%, transparent)" }}>Delivered in {lang.native}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* IVR */}
      <Section eyebrow="Multilingual IVR · 24×7" title="A voice line that answers in their language" style={{ paddingTop: 4 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 268px", gap: 16, alignItems: "stretch" }}>
          <div className="ip-card" style={{ padding: 20 }}>
            <span className="ip-tag">Inbound · parent calls</span>
            <ul className="ip-ticks" style={{ marginTop: 14 }}>
              <li><Icon name="check" size={15} stroke={2.4} />Call the school any hour, 365 days</li>
              <li><Icon name="check" size={15} stroke={2.4} />Choose a preferred language</li>
              <li><Icon name="check" size={15} stroke={2.4} />Hear attendance, results & updates instantly</li>
            </ul>
          </div>
          <div className="ip-card" style={{ padding: 20 }}>
            <span className="ip-tag">Outbound · school calls</span>
            <ul className="ip-ticks" style={{ marginTop: 14 }}>
              <li><Icon name="check" size={15} stroke={2.4} />Automatic update calls in the chosen language</li>
              <li><Icon name="check" size={15} stroke={2.4} />Attendance, exam dates, results, PTM reminders</li>
              <li><Icon name="check" size={15} stroke={2.4} />No parent left uninformed</li>
            </ul>
            <div style={{ marginTop: 14 }}><span className="ip-tag ip-tag--soon" style={{ marginTop: 14 }}>AI conversational tele-agent · coming soon</span></div>
          </div>
          {/* IVR call mock */}
          <div className="ip-phone" style={{ width: 268 }}>
            <div className="ip-phone__screen">
              <div className="ip-ivr">
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.7 }}>Incoming · School IVR</div>
                <div className="ip-ivr__av"><Icon name="voice" size={30} style={{ color: "#fff" }} /></div>
                <div className="ip-ivr__name">Soomuch Smart School</div>
                <div className="ip-ivr__status"><span className="livedot" />Connected · {student.language}</div>
                <div className="ip-ivr__lang">
                  <div style={{ opacity: 0.7, marginBottom: 6 }}>"{student.language}లో మీ పిల్లల హాజరు 92%..."</div>
                  <div style={{ display: "flex", gap: 6 }}>
                    {["1 · Attendance", "2 · Results"].map((o) => (
                      <span key={o} style={{ flex: 1, textAlign: "center", padding: "6px 4px", borderRadius: 8, background: "rgba(255,255,255,0.12)", fontSize: 10.5, fontWeight: 600 }}>{o}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <div className="ip-band" style={{ "--accent": accent }}>
        <span className="ip-band__eyebrow">Inclusive communication · One India</span>
        <div className="ip-band__title">When parents understand, they support — and children do better.</div>
        <div style={{ fontSize: 14, color: "rgba(255,255,255,0.72)", marginTop: 12, maxWidth: 620, position: "relative", lineHeight: 1.6 }}>
          Timely updates in a parent's own language keep home and school aligned — the quiet advantage behind Boards, Olympiads, JEE and NEET success.
        </div>
      </div>
    </div>
  );
}




